//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getRoomById, getHouseTypeList, updateRoomHouseType} from '../../../api/project';
import {
  getAllRoomMember,
  changeRoomMemberStatus,
  getDeliveryDataRecord
} from '../../../api/newOwner';
import OwnerWorkOrders from './conmponents/owner-workOrders';
import OwnerActivity from './conmponents/owner-activity';
import OwnerQuestionnaire from './conmponents/owner-questionnaire';
import {formatDate} from '../../../lib/date';
import PageDetailOrders from './conmponents/page-detail-orders';
import fileUploader from '../../../views/common-components/file-uploader';
import util from '../../../lib/util';
import PageDetailDeliver from './conmponents/page-detail-deliver';
import SelectMemberModal from '../../coupons/components/select-member-modal';
import PageDetailContract from './conmponents/page-detail-contract';
import PageDetailCar from './conmponents/page-detail-car';

export default {
  name: 'detail',
  components: {
    PageDetailCar,
    PageDetailContract,
    SelectMemberModal,
    PageDetailDeliver,
    PageDetailOrders, OwnerWorkOrders, OwnerActivity, OwnerQuestionnaire, fileUploader
  },
  filters: {
    formatDate(time, type) {
      var date = new Date(time);
      if (type === 1) {
        return formatDate(date, 'yyyy-MM-dd');
      }
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    }
  },
  data() {
    return {
      active: 'info',
      roomInfo: {
        members: [],
        roomOwner: {
          id: 0,
          certificate: {
            addAttrIds: [],
            delAttrIds: []
          },
          contract: {
            associateType: 'RoomContract',
            addAttrIds: [],
            delAttrIds: []
          }
        },
        houseType: {files: []}
      },
      roomId: 0,
      loading: false,
      saving: false,
      members: [],
      columns: [
        {
          type: 'index', width: 60, align: 'center'

        },
        {
          title: '姓名', key: 'name', width: 100, align: 'center',
          render: (h, params) => {
            return h('span', params.row.member.name);
          }
        },
        {
          title: '手机号', key: 'phoneNumber', align: 'center',
          render: (h, params) => {
            return h('span', params.row.member.phoneNumber);
          }
        },
        {
          title: '证件类型', key: 'cardTypeStr', align: 'center',
          render: (h, params) => {
            return h('span', params.row.member.cardTypeStr);
          }
        },
        {
          title: '证件号', key: 'cardNum', align: 'center',
          render: (h, params) => {
            return h('span', params.row.member.cardNum);
          }
        },
        {
          title: '成员类型', key: 'typeStr', align: 'center'
        },
        {
          title: '是否有效', align: 'center', key: 'isActive', slot: 'activeActions'
          // render: (h, params) => {
          //     return h('span', params.row.isActive ? '是' : '否');
          // }
        },
        {
          title: '操作', slot: 'actions', align: 'center'
        }
      ],
      ownerDetailModal: false,
      currentOwnerId: 0,
      houseTypeModal: false,
      houseTypes: [],
      downloadUrl: util.ApiUrl + 'file/download/',
      createMemberFamilyModal: false,
      mfRules: {
        type: [{required: true, message: '请选择', type: 'number', trigger: 'change'}],
        name: [{required: true, message: '请选择', type: 'string', trigger: 'blur'}]
      },
      selectMemberModal: false,
      createMemberFamilyModel: {},
      roomMembers: [],
      pdfDownloadUrl: util.ApiUrl + 'DocumentTransfer/ExportAlreadySignPDF?roomId=',
      deliveryDataRecord: {}
    };
  },
  methods: {
    onTabClick(name) {
      this.active = name;
    },
    getRoom() {
      const vm = this;
      this.loading = true;
      abp.ajax.get('/api/services/app/NewOwner/GetRoomDetail', {params: {roomId: this.roomId}}).then(res => {
        vm.roomInfo = {};
        vm.roomInfo = res.data.result;
        vm.roomInfo.roomOwner.contract = {
          associateType: 'RoomContract',
          addAttrIds: [],
          delAttrIds: []
        };
        vm.roomInfo.roomOwner.certificate = {
          addAttrIds: [],
          delAttrIds: []
        };

        vm.getHouseTypes(vm.roomInfo.projectId);
      }).finally(() => {
        this.loading = false;
      });
    },
    // getMembers() {
    //     getMembersByRoomId(this.roomId).then(res => {
    //         this.members = [];
    //         this.members.push(...res.data.result);
    //     });
    // },
    onShowOwnerDetailModal(row) {
      // this.currentOwnerId = row.id;
      // this.ownerDetailModal = true;
      this.$router.push({
        name: 'memberInfo',
        params: {id: row.memberId}
      });
    },
    getHouseTypes(projectId) {
      getHouseTypeList(projectId).then(res => {
        this.houseTypes = [];
        this.houseTypes.push(...res.data.result);
      });
    },

    onHouseTypeChange(value) {
      // console.log(value);
      const page = {
        roomId: this.roomId,
        houseTypeId: value
      };
      updateRoomHouseType(page).then(res => {
        this.houseTypeModal = false;
        this.getRoom();
      });
    },

    selectedMember(data) {
      // console.log(data);
      this.createMemberFamilyModel.name = data.name;
      this.createMemberFamilyModel.memberId = data.id;
      this.selectMemberModal = false;
    },
    saveCreateMemberFamily() {

      this.createMemberFamilyModel.roomId = this.roomId;
      this.$refs.memberFamilyRef.validate((valid) => {
        if (valid) {
          this.saving = true;
          abp.ajax.post('/api/services/app/Member/CreateMemberFamily', this.createMemberFamilyModel).then(res => {
            this.createMemberFamilyModal = false;
            this.getRoom();
            this.getMembersByRoomId();
          }).finally(() => {
            this.saving = false;
          });
        }
      });

    },
    createMemberFamily(row) {
      this.createMemberFamilyModel = {};
      this.createMemberFamilyModel = JSON.parse(JSON.stringify(row));
      this.createMemberFamilyModal = true;
    },
    onDelMemberFamily(row) {
      this.$Modal.confirm({
        title: this.L('Tips'),
        content: '确认删除该行吗？',
        okText: this.L('Yes'),
        cancelText: this.L('No'),
        onOk: async () => {
          abp.ajax.delete('/api/services/app/Member/DeleteMemberFamily', {params: {id: row.id}}).then(res => {
            this.getRoom();
            this.$Notice.success({
              title: '删除成功'
            });
          });
        }
      });
    },
    getMembersByRoomId() {
      getAllRoomMember(this.roomId).then(res => {
        this.roomMembers = [];
        this.roomMembers.push(...res.data.result);
      });
    },

    changeRoomMemberStatus(row, status) {
      var str = '';
      if (!status) {
        str = '确认停用？';
      } else {
        str = '确认启用？';
      }
      const page = {
        id: row.id,
        isActive: status
      };
      this.$Modal.confirm({
        title: this.L('Tips'),
        content: str,
        okText: this.L('Yes'),
        cancelText: this.L('No'),
        onOk: async () => {
          changeRoomMemberStatus(page).then(res => {
            this.$Notice.success({
              title: '提示',
              desc: '操作成功'
            });
            this.getMembersByRoomId();
          });
        }
      });

    },

    // getDeliveryDataRecord() {
    //   getDeliveryDataRecord(this.roomId).then(res => {
    //     this.deliveryDataRecord = {};
    //     this.deliveryDataRecord = res.data.result;
    //   });
    // },

    downloadSignPdf() {
      getDeliveryDataRecord(this.roomId, 20).then(res => {
        this.deliveryDataRecord = {};
        this.deliveryDataRecord = res.data.result;
        if (!this.deliveryDataRecord.isSign) {
          this.$Message.error('未签名');
        } else {
          let url = util.ApiUrl + 'DocumentTransfer/OwnerInformationDataPdf?roomId=' + this.roomId;
          window.open(url, '_blank');
        }
      });
    },

    hasPermission(permission) {
      return abp.auth.isGranted(permission);
    },

    onHandleDel() {
      this.$Modal.confirm({
        title: this.L('Tips'),
        content: '确认删除该房源信息',
        okText: this.L('Yes'),
        cancelText: this.L('No'),
        onOk: async () => {
          this.deleteRoomAndOwner();
        }
      })
    },

    deleteRoomAndOwner() {
      abp.ajax.delete('/api/services/app/NewOwner/DeleteRoomAndOwner?roomId=' + this.roomId).then(res => {
        this.$Notice.success({
          title: '提示',
          desc: '操作成功'
        });
        this.$router.back();
      });
    }

  },
  created() {
    this.roomId = parseInt(this.$route.params.id) || 0;
    if (this.roomId > 0) {
      this.getRoom();
      this.getMembersByRoomId();
      // this.getDeliveryDataRecord();
    }
  }
};
